// Lista de dominios europeos para facilitar mantenimiento futuro
export const EUROPEAN_DOMAINS = ['https://telefonica.admin.egg.live']

// Función mejorada que verifica si el dominio actual es europeo
export const isEuropeanDomain = (): boolean => {
    const currentOrigin = window?.location?.origin ?? ''
    return EUROPEAN_DOMAINS.includes(currentOrigin)
}
